export default "__VITE_ASSET__tdkUwDQa__"